import {Image} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import {
  BrandLogo,
  FONT_SIZES,
  ProductImage,
  Text,
  UnstyledLinkLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useMemo} from 'react';

export const AdditionalTile: React.FC<{
  ['data-testid']?: string;
  className?: string;
  href: string;
  image?: Image;
  brand?: {name: string; logo?: Image};
  label: string;
  onClick?: React.MouseEventHandler;
}> = ({
  'data-testid': dataTestId,
  className,
  href,
  image,
  brand,
  label,
  onClick,
}) => {
  const content = useMemo(() => {
    if (image && image.url) {
      return (
        <StyledProductImage
          src={image.url}
          alt={image.description}
          increasePadding
        />
      );
    }

    if (brand) {
      return (
        <BrandLogoWrapper>
          <BrandLogo name={brand.name} image={brand.logo} maxWidth="50%" />
        </BrandLogoWrapper>
      );
    }

    return null;
  }, [brand, image]);

  if (!content) {
    return null;
  }

  return (
    <li>
      <AdditionalTileWrapper
        data-testid={dataTestId}
        to={href}
        className={className}
        aria-label={undefined}
        onClick={onClick}
      >
        {content}
        <AdditionalTileLabel size="px10" weight="bold">
          {label}
        </AdditionalTileLabel>
      </AdditionalTileWrapper>
    </li>
  );
};

const AdditionalTileWrapper = styled(UnstyledLinkLinaria)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const AdditionalTileLabel = styled(Text)`
  display: block;
  padding: 10px 8px;
  line-height: 16px;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-transform: uppercase;
  text-align: center;
`;

const BrandLogoWrapper = styled.div`
  aspect-ratio: 3/4;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: ${FONT_SIZES.px16};

    ${tabletAndUpLinaria(`
      font-size: ${FONT_SIZES.px24};
    `)}
  }
`;

const StyledProductImage = styled(ProductImage)`
  > img {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  ${tabletAndUpLinaria(`
    padding-top: calc(3.85 / 3 * 100%);
  `)}
`;
